module.exports = __webpack_public_path__ + "img/service-order.1ddb2290.png";